import { DecisionType } from "../enums";
import { PolicyStates } from "../";
import { Car } from "./car-possessions-service";
import { LifePossession } from "./life-possessions-service";
import { Ubication } from "./various-risk-possessions-service";
import { Vessel } from "./vessels-possessions-service";

export interface InsurancePolicyList {
    polizas?: Array<InsurancePolicy>;
}

export interface BeneficiaryPolicy{
    nombre: string,
    cuil: string,
    clausulaNoRepeticion: string,
    isTomador: string
}

export interface InsurancePolicy {
    arse:                                           string;
    articulo:                                       string;
    beneficiariosPoliza:                            Array<BeneficiaryPolicy>;
    cantidadSiniestros:                             string;
    certificado:                                    string;
    codigoAsegurado:                                string;
    codigoProductor:                                string;
    cotizacionWeb:                                  string;
    cuicVidaObligatorio:                            string;
    descripcionRama:                                string;
    diasFaltantesVencimiento:                       string;
    embarcacion:                                    string;
    esRenovacion:                                   string;
    estados?:                                       Array<PolicyStates>;
    estaVigente:                                    DecisionType;
    expedienteGde:                                  string;
    fechaAnulacion:                                 string;
    fechaDesdeEndoso:                               string;
    fechaDeTramiteArrepentimiento:                  string;
    fechaEmision:                                   string;
    fechaHastaEndoso:                               string;
    fechaTopeDesdeEndoso:                           string;
    fechaVigDesd:                                   string;
    fechaVigHast:                                   string;
    formaDePago:                                    PaymentMethod;
    grupoDeRama:                                    BranchGroup;
    idDeTramiteArrepentimiento:                     string;
    isAnulada:                                      DecisionType;
    isWeb:                                          DecisionType;
    mailPolizaElectronica:                          string;
    moneda:                                         string;
    motivoAnulacion:                                string;
    nombreArticulo:                                 string;
    nombreAsegurado:                                string;
    nombreProductor:                                string;
    nroPoliza:                                      string;
    numeroDocAsegurado:                             string;
    numeroEndosoParaRevertir:                       string;
    operacion:                                      string;
    patente:                                        string;
    pendienteRenovacionPorSaldo:                    DecisionType;
    permiteAnulacion:                               DecisionType;
    permiteCertificadoCoberturaVidaObligatorio:     DecisionType;
    polizaAnterior:                                 string;
    possessionsType?:                               PossessionsType;
    premio:                                         string;
    prima:                                          string;
    rama:                                           string;
    saldoPendiente:                                 string;
    solicitudWeb:                                   string;
    superpoliza:                                    string;
    suscriptaPolizaElectronica:                     DecisionType;
    tieneCoberturaFinanciera:                       DecisionType;
    tieneEndosoParaRevertir:                        DecisionType;
    tieneSolicitudDeArrepentimiento:                DecisionType;
    tipoDocAsegurado:                               string;
    tipoOperacion:                                  string;
    tipoPersona:                                    string;
    vencidaNoRenovada:                              DecisionType;
    vidaColectivoSinActualizar:                     DecisionType;
    vidaLctSinActualizar:                           DecisionType;
    permiteCertificadoSinDeuda:                     string;
    permiteRenovar?:                                string;
    tipoDeDeuda:                                    string;
    statusArca:                                     string;
}



export interface FormaDePago {
    tipoDePago:                     TipoDePago;
    tarjeta:                        Tarjeta;
    numeroTarjetaDeCredito:         string;
    fechaVencimientoTarjetaDeCredi: string;
    numeroDeCbu:                    Array<NumeroDeCbuClass | string>;
}

export interface NumeroDeCbuClass {
    "$": string;
}

export interface Tarjeta {
    codigo:        string;
    nombreTarjeta: string;
}

export interface TipoDePago {
    codigo:      string;
    descripcion: string;
    efectivo:    string;
    debito:      string;
    credito:     string;
}


export interface PaymentMethod {
    tipoDePago:                     PaymentType;
    numeroDeCbu:                    string;
    tarjeta:                        CreditCard;
    numeroTarjetaDeCredito:         string;
    fechaVencimientoTarjetaDeCredi: string;
    cantidadDigitos?:               string;
    nombreBanco?:                   string;
}

export interface CreditCard {
    codigo:           string;
    nombreTarjeta?:   string;
}

export interface PaymentType {
    codigo:      string;
    descripcion: string;
    efectivo:    DecisionType;
    debito:      DecisionType;
    credito:     DecisionType;
}

export interface GetInsurancePoliciesFilter {
    insured?:   Array<string>;
    branch?:    Array<string>;
    producer?:  Array<string>;
    date:       string[];
    state?:     Array<string>;
    orderBy?:   string;
    policyNumber?: number;
    licensePlate?:   Array<string>;
}

export enum PossessionsType {
    BIENES_EMBARCACIONES = 'BIENES_EMBARCACIONES',
    BIENES_VIDA = 'BIENES_VIDA',
    BIENES_AUTOS = 'BIENES_AUTOS',
    BIENES_RIESGOS_VARIOS = 'BIENES_RIESGOS_VARIOS'
}

export type Possessions = Car | LifePossession | Ubication | Vessel;

export enum BranchGroup {
    T = 'T',
    M = 'M',
    C = 'C',
    H = 'H',
    R = 'R',
    W = 'W',
    X = 'X',
    Y = 'Y',
    Z = 'Z',
    O = 'O',
    A = 'A',
    S = 'S',
    V = 'V',
    I = 'I',
    F = 'F',
}

export const RELATION_BRANCH_WITH_POSSESSIONS: { [key in BranchGroup]: PossessionsType } = {
    [BranchGroup.T]: PossessionsType.BIENES_EMBARCACIONES,
    [BranchGroup.M]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.C]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.H]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.R]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.W]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.X]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.Y]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.Z]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.O]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.F]: PossessionsType.BIENES_RIESGOS_VARIOS,
    [BranchGroup.A]: PossessionsType.BIENES_AUTOS,
    [BranchGroup.S]: PossessionsType.BIENES_VIDA,
    [BranchGroup.V]: PossessionsType.BIENES_VIDA,
    [BranchGroup.I]: PossessionsType.BIENES_VIDA,
}

export interface PossessionsServiceResponse {
    possessions: Array<Possessions>;
}